(ns portal.adserver-ocp.view
  (:require ["@mui/material/Alert$default" :as Alert]
            ["@mui/material/Button$default" :as Button]
            ["@mui/material/CircularProgress$default" :as CircularProgress]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/Stack$default" :as Stack]
            [common.flags :refer [use-flag]]
            [common.modal.dialog :refer [deletion-confirmation form-dialog]]
            [common.modal.view :refer [defmodal]]
            [common.ocp.view :refer [defocp ocp]]
            [common.queries :refer [use-query]]
            [common.resource.query.adserver :as adserver.q]
            [common.widgets.checkbox :refer [checkbox]]
            [common.widgets.dropdown :refer [dropdown]]
            [common.widgets.form-field :refer [form-field]]
            [common.widgets.input :refer [input]]
            [portal.adserver-ocp.db :as form]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui form-field-name [{:keys [read-only]}]
  ($ form-field
     {:label "Name"
      :err-msg (form/use-error-message [:name])}
     ($ input
        (merge (form/use-bind-control [:name])
               {:disabled read-only
                :data-testid "adserver-name-input"}))))

(defui form-field-adserver [{:keys [mode]}]
  (let [adserver-options (adserver.q/use-adservers-options)
        adserver-name (form/use-current-adserver-name)
        control (form/use-bind-control [:adserver-id]
                                       {:on-change-event :form.adserver/set-adserver})]
    ($ form-field
       {:label "Adserver"
        :err-msg (form/use-error-message [:adserver-id])}
       (if (= mode :create)
         (r/as-element
          [dropdown
           (merge control {:options adserver-options})])
         ($ :span adserver-name)))))

(defui form-field-api-username [{:keys [read-only]}]
  ($ form-field
     {:label "API Username"
      :err-msg (form/use-error-message [:username])}
     ($ input
        (merge (form/use-bind-control [:username])
               {:disabled read-only}))))

(defui form-field-api-password [{:keys [read-only]}]
  ($ form-field
     {:label "API Password"
      :err-msg (form/use-error-message [:password])}
     ($ input
        (merge (form/use-bind-control [:password])
               {:type "password"
                :autoComplete "new-password"
                :disabled read-only}))))

(defui form-field-authentication
  [{:keys [read-only] :as props}]
  (let [api-access (use-subscribe [:form.adserver/api-access])]
    ($ :<>
       ($ form-field
          {:label "Authentication"
           :err-msg (form/use-error-message [:api-access])}
          ($ checkbox
             (merge (form/use-bind-control [:api-access])
                    {:label "Add 3rd party authentication"
                     :on-change #(rf/dispatch [:form.adserver/toggle-api-access])
                     :disabled? read-only
                     :id :api-access})))
       (when api-access
         ($ :<>
            ($ form-field-api-username props)
            ($ form-field-api-password props))))))

(defui dcm-profile-error
  [{:keys [user-info]}]
  ($ Stack {:spacing 0.5}
     ($ Stack {:direction "row" :spacing 1 :alignItems "center"}
        ($ Icon {:color "error"} "close")
        ($ :div (str "Authorized as " (:name user-info) " " (:email user-info))))
     ($ :div (str (:message user-info) " Please check your authorisations and settings on the DoubleClick Campaign Manager platform."))))

(defui dcm-credentials-error
  [{:keys [user-info]}]
  ($ Stack {:direction "row" :spacing 1 :alignItems "center"}
     ($ Icon {:color "error"} "close")
     ($ :div (str (:message user-info) " Please check your authorisations and settings on the DoubleClick Campaign Manager platform."))))

(defui dcm-status-ok
  [{:keys [user-info]}]
  ($ Stack {:direction "row" :spacing 1 :alignItems "center"}
     ($ Icon {:color "success"} "check")
     ($ :div (str "Authorized as " (:name user-info) " " (:email user-info)))))

(defui oauth-authorized-adform
  []
  (let [{:keys [name email]} (use-subscribe [:form.adserver/oauth-user-info])]
    ($ Stack {:alignItems "flex-start" :spacing 0.5}
       ($ Stack {:direction "row" :spacing 1 :alignItems "center"}
          ($ Icon {:color "success"} "check")
          ($ :span (str "Authorized as " name " " email)))
       ($ Button {:startIcon ($ Icon "close")
                  :variant "text"
                  :onClick #(rf/dispatch [:modal/open {:id :adserver-configuration/confirm-forget}])}
          "Remove Authorization"))))

(defmodal confirm-forget :adserver-configuration/confirm-forget [_]
  [form-dialog {:on-submit #(rf/dispatch [:form.adserver/oauth-forget])
                :submit-button-color "error"
                :modifier :warning
                :title "Please note"}
   "After removing authorization credentials, Adsets can no longer be exported to Adform with this Adserver Account."])

(defui oauth-authorized-dcm
  []
  (let [user-info (use-subscribe [:form.adserver/oauth-user-info])
        profile-options (use-subscribe [:form.adserver/dcm-profile-options])
        profile-id (use-subscribe [:form.adserver/profile-id])
        dropdown-control (form/use-bind-control [:profile-id]
                                                {:on-change-event :form.adserver/set-profile})]
    ($ Stack {:alignItems "flex-start" :spacing 0.5}
       (case (:status user-info)
         ("no-profiles" "invalid-profile") ($ dcm-profile-error {:user-info user-info})

         ("no-credentials" "invalid-credentials" "error") ($ dcm-credentials-error {:user-info user-info})

         "ok" ($ dcm-status-ok {:user-info user-info})
         nil)

       (when (seq profile-options)
         ($ Stack {:direction "row" :spacing 1 :alignItems "center" :width "100%"}
            (if profile-id
              ($ Icon {:color "success"} "check")
              ($ Icon {:color "error"} "close"))
            (r/as-element
             [dropdown
              (merge dropdown-control
                     {:options profile-options
                      :sx #js {:flex 1}})])))
       ($ Button {:startIcon ($ Icon "close")
                  :variant "text"
                  :onClick #(rf/dispatch [:modal/open {:id :adserver-configuration/confirm-forget}])}
          "Remove Authorization"))))

(defn oauth-not-authorized
  []
  ($ Stack {:alignItems "flex-start" :spacing 0.5}
     ($ Icon {:color "error"} "close")
     ($ :div "It looks like you haven't added authorization yet.")
     ($ Button {:startIcon ($ Icon "add")
                :variant "text"
                :on-click #(rf/dispatch [:form.adserver/oauth-authorize])}
        "Add Authorization")))

(defui form-field-oauth
  [{:keys [mode read-only]}]
  (let [has-oauth-access? (use-subscribe [:form.adserver/has-oauth-access?])
        current-adserver-type (use-subscribe [:form.adserver/current-adserver-type])]
    ($ form-field
       {:label "Authentication"
        :err-msg (form/use-error-message [:oauth-access])}
       (cond
         (= mode :create) ($ :p "Please configure the required authorisation after creating the adserver")

         read-only
         (if has-oauth-access?
           ($ :span "OAuth configured")
           ($ :span "No OAuth configured"))

         has-oauth-access? (case current-adserver-type
                             :adform ($ oauth-authorized-adform)
                             :dcm ($ oauth-authorized-dcm)
                             nil nil)
         :else ($ oauth-not-authorized)))))

(defui ocp-footer
  [{:keys [mode id read-only]}]
  ($ :<>
     (when (= mode :edit)
       ($ Button
          {:variant "contained"
           :color "error"
           :onClick #(rf/dispatch [:modal/open {:id :adserver/confirm-delete :props id}])}
          "Delete Adserver"))
     (when-not read-only
       ($ Button
          {:variant "contained"
           :type "submit"}
          (if (= :edit mode)
            "Save Adserver"
            "Create Adserver")))))

(defmodal confirm-delete :adserver/confirm-delete
  [id]
  [deletion-confirmation
   {:on-submit #(rf/dispatch [:form.adserver/delete id])
    :entity-name "adserver"}])

(defocp adserver-ocp :adserver/crud
  {:width "35%"}
  [{:keys [adserver]}]
  (uix/use-effect (fn []
                    (rf/dispatch [:form.adserver/init-form adserver])
                    (fn []
                      (rf/dispatch [:form.adserver/destroy])))
                  [adserver])
  (let [mode (use-subscribe [:form.adserver/mode])
        error (use-subscribe [:form.adserver/backend-error])
        show-credentials-fields (use-subscribe [:form.adserver/current-adserver-raw-credentials?])

        {:keys [isPending]} (use-query (adserver.q/adservers-query))

        xandr-enabled? (use-flag :xandr-adserver-support)
        is-xandr-adserver? (adserver.q/xandr-adserver? (get-in adserver [:adserver :id]))
        xandr-read-only? (and is-xandr-adserver? (not xandr-enabled?))]
    ($ ocp
       {:title (if adserver "Configure Adserver" "Add Adserver")
        :footer ($ ocp-footer {:mode mode
                               :id (:id adserver)
                               :read-only xandr-read-only?})
        :on-submit #(rf/dispatch [:form.adserver/submit])}
       (if isPending
         ($ Stack {:sx #js {:width "100%"
                            :height "100%"
                            :justifyContent "center"
                            :alignItems "center"}}
            ($ CircularProgress))
         ($ :<>
            (when xandr-read-only?
              ($ Alert {:severity "warning" :sx #js {:mb 2}}
                 "This Xandr (AppNexus) adserver configuration is read-only.
                  Xandr will be discontinued on February 28, 2026. Please migrate
                  to an alternative adserver."))
            ($ form-field-name {:read-only xandr-read-only?})
            ($ form-field-adserver {:mode mode})
            (if show-credentials-fields
              ($ form-field-authentication {:read-only xandr-read-only?})
              ($ form-field-oauth {:mode mode :read-only xandr-read-only?}))
            (when error
              ($ Alert {:severity "error"}
                 error)))))))

